import axios from 'axios';
import { API_URL, DEBUG_MODE } from '../config';

// Create an axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    // If token exists, add to headers
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    if (DEBUG_MODE) {
      console.log(`🚀 API Request: ${config.method.toUpperCase()} ${config.url}`, 
        config.data ? config.data : '');
    }
    
    return config;
  },
  (error) => {
    if (DEBUG_MODE) {
      console.error('❌ Request Error:', error);
    }
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    if (DEBUG_MODE) {
      console.log(`✅ API Response: ${response.config.url}`, response.data);
    }
    return response;
  },
  (error) => {
    if (DEBUG_MODE) {
      console.error('❌ Response Error:', error);
      console.error('Response:', error.response?.data);
      console.error('Status:', error.response?.status);
    }
    
    // Handle token expiration
    if (error.response?.status === 401) {
      // Check if it's a token issue
      if (error.response.data?.message?.includes('token')) {
        localStorage.removeItem('token');
        window.location.href = '/login?session=expired';
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
